// this file added by Bearer Web Developer
export const validatePhone = (value: string) => {
    value = value?.slice(4);
    if (value.length === 0) return "Mobile Number is required (Beginning with +614)";
    if (!(value.length === 8)) return "8 Digits (Beginning with +614)";
    if (!value.match(/^[0-9]*$/)) return "8 Digits (Beginning with +614)";
}